import React from 'react';
import { connect } from 'react-redux';
import { Button, Icon} from 'antd';
import { percentageColor } from '../util/util';

const ItemBlock = ({ items, name, showModal }) => {
    return (
        <div className="table">
            {
                typeof name !== 'undefined' && name !== '' ?
                    (
                        <div className="label">
                            <span className="name">{name}</span>
                        </div>
                    ) : ''
            }
            {items.map((item,ndx) => {
                const performance = name && name !== '' ? item.groupedPerformance : item.performance;
                const perfWidth = performance > 120 ? 120 : (performance < 0 ? 0 : performance);
                const namePart = item.systemId ? `${item.systemId} - [${item.id}] ${item.name} (Wp: ${item.wp})` : `${item.id} ${item.name} (Wp: ${item.wp})`;
                   return(
                    <div key={ndx} className={`location ${percentageColor(performance / 100, true)}`}>
                        <span className="name">{namePart}</span>
                        <span className="value">{item.cp.toFixed(0)} ({performance.toFixed(0)}%)</span>
                        <span className="clear"></span>
                        <div style={{width: (perfWidth / 1.2).toFixed(0) + "%"}}></div>
                        <Button type="dashed" ghost={true} id={item.id} name={item.name} className="graph-button" size="small" onClick={showModal} style={{zIndex:'101'}}><Icon type="line-chart" style={{zIndex:'100'}}/></Button>
                    </div>
                );
            })}
        </div>
    )
};

export default connect()(ItemBlock);



// WEBPACK FOOTER //
// ./src/components/ItemBlock.js